import { Flex, Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import React, { useMemo } from "react";
import { useProfileStore } from "../../../../../stores/UserStore";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconLinkedin } from "../../../../../components/Icons/IconLinkedin";
import { IconEmail } from "../../../../../assets/icons/IconEmail";
import { IconDeviceMobile, IconUserSearch } from "@tabler/icons-react";

const BillingChanged = ({ productsMap }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);

  const defaultValuesStart = useMemo(() => {
    const userProducts = profile?.subscriptions?.products;

    if (userProducts.length) {
      return {
        email:
          userProducts.find((x) => x.sub_type === "smtp")?.quantity * 5 || 0,
        linkedin:
          userProducts.find((x) => x.sub_type === "linkedin")?.quantity * 1 ||
          0,
        enrich:
          userProducts.find((x) => x.sub_type === "enrich")?.quantity * 1000 ||
          0,
        mobile:
          userProducts.find((x) => x.sub_type === "mobile")?.quantity * 100 ||
          0,
      };
    }

    return {
      email: profile?.permissions.find(
        (x) => x.name === "maxIntegrationsEmailSMTP"
      )?.default_value,
      linkedin: profile?.permissions.find(
        (x) => x.name === "maxIntegrationsLinkedin"
      )?.default_value,
      enrich: profile?.permissions.find(
        (x) => x.name === "maxEmailsGeneratedPerMonth"
      )?.default_value,
      mobile: profile?.permissions.find(
        (x) => x.name === "maxMobilePhonesGeneratedPerMonth"
      )?.default_value,
    };
  }, [profile?.permissions, profile?.subscriptions?.products]);

  const email = useMemo(() => {
    const removedProduct =
      profile.subscriptions?.options_remove_renewal?.find(
        (x) => x.product_id === productsMap?.email_product?.product_id
      )?.quantity || 0;

    return defaultValuesStart.email - removedProduct * 5;
  }, [
    defaultValuesStart.email,
    productsMap?.email_product?.product_id,
    profile.subscriptions?.options_remove_renewal,
  ]);
  const linkedin = useMemo(() => {
    const removedProduct =
      profile.subscriptions?.options_remove_renewal?.find(
        (x) => x.product_id === productsMap?.linkedin_product?.product_id
      )?.quantity || 0;

    return defaultValuesStart.linkedin - removedProduct;
  }, [
    defaultValuesStart.linkedin,
    productsMap?.linkedin_product?.product_id,
    profile.subscriptions?.options_remove_renewal,
  ]);
  const enrich = useMemo(() => {
    const removedProduct =
      profile.subscriptions?.options_remove_renewal?.find(
        (x) => x.product_id === productsMap?.enrich_product?.product_id
      )?.quantity || 0;

    return defaultValuesStart.enrich - removedProduct * 1000;
  }, [
    defaultValuesStart.enrich,
    productsMap?.enrich_product?.product_id,
    profile.subscriptions?.options_remove_renewal,
  ]);

  const mobile = useMemo(() => {
    const removedProduct =
      profile.subscriptions?.options_remove_renewal?.find(
        (x) => x.product_id === productsMap?.mobile_product?.product_id
      )?.quantity || 0;

    return defaultValuesStart.mobile - removedProduct * 100;
  }, [
    defaultValuesStart.mobile,
    productsMap?.mobile_product?.product_id,
    profile.subscriptions?.options_remove_renewal,
  ]);

  return (
    <Stack bg={"red.2"} p={"md"} style={{ borderRadius: 8 }} justify={"center"} mb={16}>
      {profile?.subscriptions?.next_monthly_amount <
      profile?.subscriptions?.monthly_amount ? (
        <Text fw={500}>{lang.pricing.downgraded} :</Text>
      ) : profile?.subscriptions?.next_monthly_amount >
        profile?.subscriptions?.monthly_amount ? (
        <Text fw={500}>{lang.pricing.upgraded} :</Text>
      ) : (
        ""
      )}

      <Group p={"md"} bg={"white"} style={{ borderRadius: 8 }}>
        <Stack>
          <Group>
            <ThemeIcon color="orange" variant="subtle">
              <IconLinkedin size={20} />
            </ThemeIcon>
            <Text size="lg">
              <b>{linkedin}</b> {lang.pricing.linkedin_accounts}
            </Text>
          </Group>
          <Group>
            <ThemeIcon color="orange" variant="subtle">
              <IconEmail size={20} />
            </ThemeIcon>
            <Text size="lg">
              <b>{email}</b> {lang.pricing.emails}
            </Text>
          </Group>
          <Group>
            <ThemeIcon color="tertiary.8" variant="subtle">
              <IconUserSearch size={20} />
            </ThemeIcon>
            <Text size="lg">
              <b>{enrich}</b> {lang.pricing.enrich_monthly}
            </Text>
          </Group>
          <Group>
            <ThemeIcon color="tertiary.8" variant="subtle">
              <IconDeviceMobile size={20} />
            </ThemeIcon>
            <Text size="lg">
              <b>{mobile}</b> {lang.settings.mobile_phone_per_month}
            </Text>
          </Group>
        </Stack>

        <Text fz={32} fw={600} mx={"auto"}>
          {profile?.subscriptions?.next_monthly_amount}€ HT
        </Text>
      </Group>
    </Stack>
  );
};

export default BillingChanged;
